import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IFieldConfigResponse } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_DATA_FIELDS_QUERY_KEY } from "../constants";

export function useGetBriefDataFields(briefId: string) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<IFieldConfigResponse>
  >({
    queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefDataFields(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    dataFields: data?.data,
    isFetching: isLoading,
  };
}
